import React from 'react'
import './SummaryProductOldBudgetMobile.scss'
import { firstCharCapitalize } from '../utils/utils'
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

export const SummaryProductOldBudgetMobile = (props) => {
    const { productBudget } = props
    return (
        <div className="summary-product-old-budget-mobile-container">
            <div className="img">
                <img src={"/static/imgProducts/tn_" + productBudget.product.Fotografia + "_p.jpg"} onError={(e) => {
                    e.target.onerror = null
                    e.target.src = '/static/img/no-imagen-fansa.png'
                }} alt="" />
            </div>
            <div className="info">
                <div className="data producto">
                    <p className="title">Producto</p>
                    <p className="data-info">{firstCharCapitalize(productBudget.product.Descripcion)}</p>
                </div>
                <div className="data referencia">
                    <p className="title">Referencia</p>
                    <p className="data-info">{productBudget.product.RefSuelto}</p>
                </div>
                <div className="data formato">
                    <p className="title">Formato</p>
                    {productBudget.format === 'UVenta2021Suelto' && productBudget.product.Descripcion.toLowerCase().indexOf('set/') > -1 && <p className="data-info">Set</p>}
                    {productBudget.format === 'UVenta2021Suelto' && productBudget.product.Descripcion.toLowerCase().indexOf('set/') === -1 && <p className="data-info">Unidad</p>}
                    {productBudget.format === 'UnidadesPack' && <p className="data-info">Pack</p>}
                    {productBudget.format === 'UnidadesPallet' && <p className="data-info">Pallet</p>}
                    {productBudget.format === 'expositor' && <p className="data-info">Expositor</p>}
                </div>
                <div className="data cantidad">
                    <p className="title">Cantidad</p>
                    <p>{productBudget.quantity}</p>
                </div>
                <div className="data total">
                    <p className="title">Total</p>
                    <p className="data-info">{productBudget.total} un</p>
                </div>
            </div>
        </div>
    )
}
